/*
 * ****************************************************************************
 *     Copyright (C)  Motorola Solutions, INC.
 *     All Rights Reserved.
 *     Motorola Solutions Confidential Restricted.
 * ****************************************************************************
 */

import { createFeature, createReducer, on } from '@ngrx/store';
import {
    updateAgentFilter,
    updateCallFilter,
    updateQueueFilter,
    updateTabIndex
} from "./supervisor-view.actions";

export interface SupervisorViewState {
    agentFilter: string;
    callFilter: string;
    queueFilter: string;
    tabIndex: number;
}

const initialState: SupervisorViewState = {
    agentFilter: '',
    callFilter: '',
    queueFilter: '',
    tabIndex: 0
};

export const supervisorViewFeature = createFeature({
    name: 'supervisor-view',
    reducer: createReducer(
        initialState,
        on(updateAgentFilter, (state, {filter}): SupervisorViewState => {
            return { ...state, agentFilter: filter };
        }),
        on(updateCallFilter, (state, {filter}): SupervisorViewState => {
            return { ...state, callFilter: filter };
        }),
        on(updateQueueFilter, (state, {filter}): SupervisorViewState => {
            return { ...state, queueFilter: filter };
        }),
        on(updateTabIndex, (state, {index}): SupervisorViewState => {
            return { ...state, tabIndex: index };
        })
    )
});
